import type { Event } from '@/types/event';
import type { ReportEventDetail } from '@/types/report';
import { confidenceToPercentage } from '@/utils/report-event-confidence';

export function reportEventDetailToEvent(
    detail: ReportEventDetail,
): Event & { confidence?: number } {
    return {
        id: detail.eventId ?? detail.id,
        createdAt: detail.createdAt,
        updatedAt: detail.updatedAt,
        frames: detail.frames,
        snapshotFrameId:
            detail.thumbnailFrames[0]?.id ?? detail.frames[0]?.id ?? 0,
        description: detail.description ?? undefined,
        classId: detail.classId,
        sourceId: detail.sourceId,
        sourceName: detail.sourceName,
        sourceType: detail.sourceType,
        thumbnailUrl: detail.thumbnailUrls[0],
        confidence:
            detail.confidence == null
                ? undefined
                : confidenceToPercentage(detail.confidence),
    };
}
